import type { InitialState } from '@/app';
import { isAtLeastRole } from '@/utils/roleHierarchy';

export default (initialState: InitialState) => {
  const { currentUser } = initialState || {};
  const role = currentUser?.role;

  const isMarketingOrHr =
    isAtLeastRole(role, 'MARKETING') || isAtLeastRole(role, 'HR');
  const isIntegration = isAtLeastRole(role, 'INTEGRATION');
  const isAdmin = isAtLeastRole(role, 'ADMIN');

  return {
    canAccessStores: isMarketingOrHr || isIntegration,
    canModifyStores: isMarketingOrHr,
    canAccessBeneficiaries: isMarketingOrHr,
    canModifyBeneficiaries: isMarketingOrHr,
    canAccessSegments: isMarketingOrHr,
    canModifySegments: isMarketingOrHr,
    canAccessRoleSegments: isAdmin,
    canAccessRoles: isMarketingOrHr,
    canAccessUserRoles: isAdmin,
    canAccessUsers: isMarketingOrHr,
  };
};
